import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { PengeinstitutterService } from '../pengeinstitutter.service';
import { PiSearchParams } from './pi-search-params.model';
import { Message } from 'primeng/message';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-pi-search',
  imports: [Button, ReactiveFormsModule, InputText, Message, Select],
  templateUrl: './pi-search.component.html',
  styleUrl: './pi-search.component.css'
})
export class PiSearchComponent {
  piService = inject(PengeinstitutterService);
  data = this.piService.datasource.data;

  itcOptions = ['BD', 'BEC', 'SDC'];

  form = new FormGroup({
    navn: new FormControl(),
    regnr: new FormControl(),
    itCentral: new FormControl()
  });

  onClickSearch() {
    this.piService.searchPi({ ...this.form.value as PiSearchParams, searchTime: new Date() });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (this.data.value() && this.data.value()?.totalRowCount == 0);
  });

}
